import React from 'react';
import { EVALUATION_LOGS } from 'features/logs/queries';
import { Card } from '@totalsoft/rocket-ui';
import ListAltIcon from '@mui/icons-material/ListAlt';
import ListBrowser, { getListBrowserStore } from '@ts-private/list-browser';
import EvaluationLogComponent from './EvaluationLogComponent';
import ExportModalComponent from 'features/common/export/ExportModalComponent';
import { useListBrowserFunctions } from 'utils/hooks/useListBrowserFunctions';
import { useApolloFetching } from '@ts-private/list-browser-apollo-extensions';
import useEvaluationLogFilters from './useEvaluationLogFilters';

export const logsStore = getListBrowserStore({
  name: 'evaluation-logs-browser',
  filterDefinitions: [
    {
      name: 'id',
      caption: 'EvaluationLogs.ID',
      type: 'text'
    },
    {
      name: 'entity_PK1',
      caption: 'EvaluationLogs.Entity_PK1',
      type: 'integer'
    },
    {
      name: 'entity_PK2',
      caption: 'EvaluationLogs.Entity_PK2',
      type: 'integer'
    },
    {
      name: 'entityType',
      caption: 'EvaluationLogs.EntityType',
      type: 'text'
    },
    {
      name: 'source',
      caption: 'EvaluationLogs.Source',
      type: 'text'
    },
    {
      name: 'additionalInfo',
      caption: 'EvaluationLogs.AdditionalInfo',
      type: 'text'
    },
    {
      name: 'evaluationDate',
      caption: 'EvaluationLogs.EvaluationDate',
      type: 'date'
    },
    {
      name: 'evaluationTime',
      caption: 'EvaluationLogs.EvaluationTime',
      type: 'time'
    },
    {
      name: 'evaluationEndDate',
      caption: 'EvaluationLogs.EvaluationEndDate',
      type: 'date'
    },
    {
      name: 'evaluationEndTime',
      caption: 'EvaluationLogs.EvaluationEndTime',
      type: 'time'
    }
  ],
  orderByFields: [
    {
      caption: 'EvaluationLogs.EvaluationDate',
      value: 'EvaluationDate'
    }
  ],
  pager: {
    orderBy: 'EvaluationDate',
    direction: 'desc'
  }
});

const logsFetchingOptions = {
  queryOptions: { query: EVALUATION_LOGS, name: 'evaluationLogs', fetchPolicy: 'network-only' }
};

const EvaluationLogListBrowser = () => {
  useApolloFetching(logsStore, logsFetchingOptions);
  const { textResolver } = useListBrowserFunctions();

  useEvaluationLogFilters();

  return (
    <Card icon={ListAltIcon}>
      <ListBrowser store={logsStore} ItemComponent={EvaluationLogComponent} textResolver={textResolver} />
      <ExportModalComponent store={logsStore} options={logsFetchingOptions} />
    </Card>
  );
};

export default EvaluationLogListBrowser;
